import moment from "moment";
import "moment/dist/locale/th";

export const thaiYear = (date: string|undefined|null, format: string) => {
  const momentDate = date ? moment(date) : moment();
  const christianYear = momentDate.format('YYYY');
  const buddhishYear = (parseInt(christianYear) + 543).toString();
  return momentDate.format(format.replace('YYYY', buddhishYear).replace('YY', buddhishYear.substring(2, 4))).replace(christianYear, buddhishYear);
};